import { Box, Collapse, Typography, useTheme } from '@mui/material';
import { GantWP } from './GantWP';
import { tokens } from '../../../global/theme/tokens';
import { WorkPackageForm } from '../project/workPackage/WorkPackageForm';
import { useState } from 'react';
import { updateOrCreate } from '../../special/updateOrCreate';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
export const GantPhase = ({
  phase,
  isFirst,
  dayWidth,
  onChange,
  days,
  inEditMode,
  projectId,
  resolution,
}) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode, theme.palette.colorTheme);

  const { name, workPackages } = phase;
  const [showPackages, setShowPackages] = useState(true);

  const [editWP, setEditWP] = useState(null);
  function handleUpdateWorkPackage(updatedWP) {
    const newWorkPackages = updateOrCreate(workPackages, updatedWP);

    onChange({ ...phase, workPackages: newWorkPackages });
  }
  return (
    <Box
      sx={{
        borderTop: `1px dashed ${colors.card}`,
      }}
      className="pb-4"
    >
      <Typography
        fontWeight={600}
        className="pl-2 pt-[1px] cursor-pointer"
        onClick={() => setShowPackages(!showPackages)}
      >
        <ArrowDropDownIcon
          sx={{
            transform: `rotate(${showPackages ? 180 : 0}deg)`,
          }}
          className="mr-1"
        />
        {name}
      </Typography>
      <Collapse in={showPackages}>
        <Box className="flex flex-col gap-1 pt-2">
          {workPackages?.map((workPackage) => (
            <GantWP
              key={workPackage.id}
              workPackage={workPackage}
              dayWidth={dayWidth}
              onEdit={setEditWP}
              days={days}
              inEditMode={inEditMode}
              projectId={projectId}
              onChange={handleUpdateWorkPackage}
              resolution={resolution}
            />
          ))}
        </Box>
      </Collapse>
      <WorkPackageForm
        phaseId={phase.id}
        open={Boolean(editWP)}
        onClose={() => setEditWP(null)}
        startDataCollection={editWP}
        onChange={handleUpdateWorkPackage}
      />
    </Box>
  );
};
